










































































































































import { Component, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { PatientFilter } from "@/store/modules/types";

@Component({
  computed: mapState("gaps", ["insurers"])
})
export default class PatientSearch extends Vue {
  @Model("change") readonly filter!: PatientFilter;
}
